import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-your-plan-hero-item',
  templateUrl: './your-plan-hero-item.component.html',
  styleUrls: ['./your-plan-hero-item.component.scss'],
})
export class YourPlanHeroItemComponent implements OnInit {
  @Input() indent = false;
  @Input() context: 'positive' | 'neutral' | 'negative' = 'positive';

  constructor() { }

  ngOnInit() { }
}
